import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService, LanguageService } from 'vhobjects-service/src/services';
import { AtwContentPreviewSliderAdmin } from 'vhobjects-admin';

@Component({
  selector: 'atw-content-preview-slider-config',
  templateUrl: './content-preview-slider-config.component.html',
  styleUrls: ['./content-preview-slider-config.component.scss']
})
export class AtwContentPreviewSliderConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any; // xem đang ở page hay admin

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'cau_hinh_bo_goc',
      index: 1,
    },
  ];

  id_subproject: any = "";
  subProject: any = {};
  openMap: { [name: string]: boolean; } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator: VhEventMediator,
    private functionService: FunctionService,
    private nzModalService: NzModalService,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    this.subProject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
  }

  openModalEdit() {
    this.staticdata.datas.forEach((item) => {
      item._id ??= (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    });
    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: this.languageService.translate('chinh_sua_noi_dung'),
      nzWidth: '80%',
      nzContent: AtwContentPreviewSliderAdmin,
      nzComponentParams: {
        data: { ...this.objectChoosing },
        type: 'page'
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
      // this.vhEventMediator.notifyOnConfigChanged({
      //   status: 'config-changed',
      //   code: this.objectChoosing._id,
      // });
    });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['content-preview-slider']['width'] = event.width + 'px';
    if (event.height) this.class['content-preview-slider']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass();
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(
      this.objectChoosing._id, 
      { [this.device + '_class']: this.class }
    ).then((bool: any) => {});
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(
      this.objectChoosing._id, 
      { [this.device + '_config']: this.config }
    ).then((bool: any) => {});
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(
      this.objectChoosing._id, 
      { staticdata: this.staticdata }
    ).then((bool) => {});
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    return this.vhQueryAutoWeb.updateObject(
      this.objectChoosing._id, 
      { 
        [this.device + '_class']: this.class, 
        [this.device + '_config']: this.config, 
        staticdata: this.staticdata 
      }
    ).then((bool: any) => {});
  }
}
